/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Delete_Transfer_EquipmentInputs */



/**
* | output |
* | --- |
* | "Equipment is still associated with this gateway. Move it before deleting." |
*
* @param {Gateway_Delete_Transfer_EquipmentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_delete_transfer_equipment = /** @type {((inputs?: Gateway_Delete_Transfer_EquipmentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Delete_Transfer_EquipmentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Equipment is still associated with this gateway. Move it before deleting.")
	return /** @type {LocalizedString} */ ("Des équipements sont encore associés à cette box. Déplacez-les avant de supprimer.")
});